import {
  COURSE_NAVIGATION_DATA_SET,
  COURSE_NAVIGATION_SET_COURSE_ADMIN,
  COURSE_NAVIGATION_SET_COHORT_ADMIN,
  COURSE_NAVIGATION_SET_CERTIFICATION,
  COURSE_NAVIGATION_SET_ASSESSMENT,
  COURSE_NAVIGATION_LOAD_START,
  COURSE_NAVIGATION_LOAD_FAIL,
} from './actions';
import Resource from '../../resource/Resource';

import './injectReducers';
import {
  selectCourseAdminExpanded,
  selectCohortAdminExpanded,
  selectCertificationExpanded,
  selectAssessmentExpanded,
  selectIsCurrentCourseLoadingNavData,
  selectHasLoadedCurrentCourseNavData,
} from './selectors';
import { selectCurrentCoursePath } from '../Courses/selectors';
import { currentCohortPathSelector } from '../Auth/selectors';
import { fetchCurrentUserFrontChatData } from '../Auth/dispatchers';
import { GTM } from '../../web/metrics/google-tag-manager';
import { initializeIdentitySession } from '../IdentitySession/dispatchers';
import { getEnabledWidgetIntegrationProviders } from '../WidgetIntegrations/dispatchers';

export function setNavigationData(coursePath, navigationData) {
  const {
    enrolments,
    institutions,
    portals,
    courses,
    qualifications,
    roles,
    navigation,
    certification,
    certificationPathway,
  } = navigationData;
  return {
    type: COURSE_NAVIGATION_DATA_SET,
    coursePath,
    enrolments,
    institutions,
    portals,
    courses,
    qualifications,
    roles,
    navigation,
    certification,
    certificationPathway,
  };
}

export const courseNavigationLoadStart = (coursePath) => {
  return {
    type: COURSE_NAVIGATION_LOAD_START,
    coursePath,
  };
};

export const courseNavigationLoadFail = (coursePath) => {
  return {
    type: COURSE_NAVIGATION_LOAD_FAIL,
    coursePath,
  };
};

export const loadCurrentCourseNavigationData = (dispatch, getState) => {
  setTimeout(() => {
    // setTimeout so that the current cohort path is available
    const state = getState();
    const currentCoursePath = selectCurrentCoursePath(state);
    const isEnrolled = !!currentCohortPathSelector(state);

    if (
      !selectHasLoadedCurrentCourseNavData(state) &&
      !selectIsCurrentCourseLoadingNavData(state) &&
      isEnrolled
    ) {
      dispatch(courseNavigationLoadStart(currentCoursePath, true));

      // Note: dispatch fetchCurrentUserFrontChatData with load course navigation data
      // because front chat is only servered for course admin at the time of being inside
      // of course
      dispatch(fetchCurrentUserFrontChatData(currentCoursePath)).then(
        ({ success, email, userHash }) => {
          if (success) {
            GTM.pushEvent('loadFrontChat', { email, userHash });
          }
        }
      );

      Resource.read('course', currentCoursePath, 'getNavigationData')
        .then((navigationData) => {
          dispatch(setNavigationData(currentCoursePath, navigationData));
          dispatch(initializeIdentitySession);
          dispatch(getEnabledWidgetIntegrationProviders());
        })
        .fail(() => {
          dispatch(courseNavigationLoadFail(currentCoursePath, false));
        });
    }
  }, 0);
};

export const toggleCourseAdminExpanded = () => {
  return (dispatch, getState) => {
    dispatch({
      type: COURSE_NAVIGATION_SET_COURSE_ADMIN,
      expanded: !selectCourseAdminExpanded(getState()),
    });
  };
};

export const toggleCohortAdminExpanded = () => {
  return (dispatch, getState) => {
    dispatch({
      type: COURSE_NAVIGATION_SET_COHORT_ADMIN,
      expanded: !selectCohortAdminExpanded(getState()),
    });
  };
};

export const toggleCertificationExpanded = () => {
  return (dispatch, getState) => {
    dispatch({
      type: COURSE_NAVIGATION_SET_CERTIFICATION,
      expanded: !selectCertificationExpanded(getState()),
    });
  };
};

export const toggleAssessmentExpanded = () => {
  return (dispatch, getState) => {
    dispatch({
      type: COURSE_NAVIGATION_SET_ASSESSMENT,
      expanded: !selectAssessmentExpanded(getState()),
    });
  };
};
